import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateRemoteRefreshExpectedDurationParams {
  id: string;
  expectedRefreshDuration: string;
}

export class UpdateRemoteRefreshExpectedDurationRequest extends Request<IUpdateRemoteRefreshExpectedDurationParams, IResult> {
  constructor(params: IUpdateRemoteRefreshExpectedDurationParams) {
    super('setDatasourceRemoteExpectedRefreshDuration', params);
  }
}
